import { Card, styled } from '@mui/material';

const PREFIX = 'AccountProfile';

export const classes = {
  root: `${PREFIX}-root`,
  details: `${PREFIX}-details`,
  avatar: `${PREFIX}-avatar`,
  locationText: `${PREFIX}-locationText`,
  dateText: `${PREFIX}-dateText`,
  progress: `${PREFIX}-progress`,
  uploadButton: `${PREFIX}-uploadButton`,
};

export const StyledCard = styled(Card)(({ theme }) => ({
  [`&.${classes.root}`]: {},

  [`& .${classes.details}`]: {
    display: 'flex',
  },

  [`& .${classes.avatar}`]: {
    marginLeft: 'auto',
    height: 110,
    width: 100,
    flexShrink: 0,
    flexGrow: 0,
  },

  [`& .${classes.locationText}`]: {},
  [`& .${classes.dateText}`]: {},

  [`& .${classes.progress}`]: {
    marginTop: theme.spacing(2),
  },

  [`& .${classes.uploadButton}`]: {
    marginRight: theme.spacing(2),
  },
}));